type stateType = { number: number }

export const state = () => ({
  number: 0,
})

export const mutations = {
  setNumber(state: stateType, number: number) {
    if (!isNaN(number)) {
      state.number = parseInt(String(number))
    }
  },
  increase(state: stateType, number: number = 1) {
    state.number += parseInt(String(number))
  },
  decrease(state: stateType, number: number = 1) {
    state.number -= parseInt(String(number))
    if (state.number < 1) state.number = 0
  },
}

export const getters = {
  getNumber(state: stateType) {
    return state.number
  },
}
